import type { ELanguages } from '@common/enums';
import { EAppMode, UserPlatform } from '@common/enums';
import type { AppState } from './app.reducer';
import { APP_FEATURE_KEY } from './app.reducer';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectShopSettings } from '@web/store/website/settings/settings.selectors';

export const selectAppState = createFeatureSelector<AppState>(APP_FEATURE_KEY);

export const selectIsReady = createSelector(selectAppState, (state: AppState): boolean => state.isReady);

export const selectIsAdmin = createSelector(selectAppState, (state: AppState): boolean => state.isAdmin);

export const selectMode = createSelector(selectAppState, (state: AppState): EAppMode => state.mode);

export const selectIsEcommerceModeShallow = createSelector(selectMode, (mode: EAppMode): boolean => {
    return mode === EAppMode.ECOMMERCE;
});

export const selectIsEcommerceMode = createSelector(
    selectMode,
    selectShopSettings,
    (mode, shopSettings): boolean => mode === EAppMode.ECOMMERCE && shopSettings?.enabled
);

export const selectError = createSelector(selectAppState, (state: AppState): string => state.error);

export const selectLocale = createSelector(selectAppState, (state: AppState): ELanguages => state.locale);

export const selectIsMacOS = createSelector(
    selectAppState,
    (state: AppState): boolean => state.platform === UserPlatform.mac
);

export const selectDataLayer = createSelector(selectAppState, (state: AppState): any => state.dataLayer);
